/**
 * Lightweight server-status store using useSyncExternalStore (React 18+).
 * Replaces @reduxjs/toolkit + react-redux for this single boolean, saving ~70 KB.
 * The store can be read from React via the useServerStatus hook and written from
 * non-React code (e.g. apiUtils) via setServerDown.
 */
import { useSyncExternalStore } from 'react';

let isServerDown = false;
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => isServerDown;
// API reachability is browser state; public HTML starts with the login enabled.
const getServerSnapshot = () => false;

export const setServerDown = (down: boolean) => {
  if (isServerDown !== down) {
    isServerDown = down;
    listeners.forEach(l => l());
  }
};

export const useServerStatus = () =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
